<template>
  <div class="team-wrapper">
    <div class="title my-3">Team</div>
    <div class="team-content d-flex justify-content-center">
      <saru-equipment
        v-for="(item, inx) in toTokenIds"
        :key="`pksaru-${item.tokenId}`"
        :tokenId="item.tokenId"
        :meta="toMeta"
        :items="toItemIds[inx]"
        :saruInx="inx"
        @onClick="onClickItem"
      />
    </div>
    <div class="team-action d-flex justify-content-center my-3">
      <b-btn
        class="px-4 btn-team btn-import"
        @click="$bvModal.show('import-team-modal')"
        >Import</b-btn
      >
      <b-btn
        class="px-4 btn-team btn-update"
        @click="$bvModal.show('select-team-modal')"
        >Update</b-btn
      >
    </div>
    <b-modal
      id="select-team-modal"
      title="SELECT TEAM"
      body-class="modal-team-body"
      footer-class="modal-claim-footer"
      hide-footer
      centered
      scrollable
    >
      <template #default="{ close }">
        <SelectTeam @onClose="close" />
      </template>
    </b-modal>
    <b-modal
      id="import-team-modal"
      title="import"
      body-class="modal-team-body"
      footer-class="modal-claim-footer"
      hide-footer
      centered
      scrollable
    >
      <template #default="{ close }">
        <ImportTeam @close="close" />
      </template>
    </b-modal>

    <b-modal id="bp-modal" hide-footer hide-header centered>
      <template #default="{ close }">
        <div>
          <div :class="`wrapper-modal ${utils.toBgItem(info)}`">
            <b-img :src="info.thumbnail" :class="`${utils.toBgItem(info)}`" />
          </div>
          <div class="battle-power">
            <div
              class="bp-item"
              v-for="it in items"
              :key="`bp-${it.key}`"
              v-b-tooltip.hover
              :title="it.key.toLocaleUpperCase()"
            >
              <b-img :src="it.icon" />
              <span class="ml-2">{{ info[it.key] }}</span>
            </div>
          </div>
          <b-btn-close @click="close"></b-btn-close>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import iSlash from "@/assets/icons/slash.png";
import iHeavy from "@/assets/icons/heavy.png";
import iStrike from "@/assets/icons/strike.png";
import iTech from "@/assets/icons/tech.png";
import iMagic from "@/assets/icons/magic.png";
import { mapGetters } from "vuex";
import SelectTeam from "./SelectTeam.vue";
import ImportTeam from "./ImportTeam.vue";
import { BigNumber, ethers } from "ethers";
import { parseEther } from "ethers/lib/utils";

export default {
  name: "SaruTeam",
  components: { SelectTeam, ImportTeam },
  computed: mapGetters("saru", ["toTokenIds", "toItemIds", "toMeta"]),
  data: () => ({
    sarus: [],
    info: null,
    items: [
      {
        icon: iTech,
        key: "tech",
      },
      {
        icon: iMagic,
        key: "magic",
      },
      {
        icon: iSlash,
        key: "slash",
      },
      {
        icon: iHeavy,
        key: "heavy",
      },
      {
        icon: iStrike,
        key: "strike",
      },
    ],
  }),
  methods: {
    onImport() {},
    onUpdate() {},
    onClickItem(item, isSaru) {
      const temp = { thumbnail: item.thumbnail };
      let powerTotal = 0;
      this.items.forEach(function ({ key }) {
        if (isSaru) {
          temp[key] =
            Math.floor(
              (item.stats.attack[key] + item.stats.defend[key]) * 100
            ) / 100.0;
        } else {
          let stats = item.stats.attack;
          if (!stats) {
            stats = item.stats.defend;
          }
          temp[key] =
            BigNumber.from(stats[key]).div(ethers.utils.parseUnits("1", 16)) /
            100.0;
        }
        powerTotal = powerTotal + temp[key];
      });
      temp["isSaru"] = isSaru;
      temp["powerTotal"] = parseEther(`${powerTotal}`);
      this.info = temp;
      this.$bvModal.show("bp-modal");
    },
  },
};
</script>

<style lang="scss" scoped>
.team-wrapper {
  .title {
    text-transform: uppercase;
    font-size: 30px;
    line-height: 36px;
    font-weight: 600;
    text-align: center;
  }
  .team-content {
    gap: 16px;
    flex-wrap: wrap;
  }

  .team-action {
    gap: 16px;
    .btn-team {
      cursor: pointer;
      border: none;
      width: 202px;
      height: 62px;
      flex-shrink: 0;
      color: #fff;
      text-align: center;
      font-size: 24px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      letter-spacing: 0.72px;
      text-transform: uppercase;
      @media (max-width: 767px) {
        width: 150px;
        height: 48px;
        font-size: 20px;
      }
      &:active,
      &:focus {
        border: none;
        box-shadow: none;
      }
      &.btn-import {
        background: url("~@/assets/icons/btn-button.svg");
        background-size: cover;
      }
      &.btn-update {
        background: url("~@/assets/icons/btn-boost.svg");
        background-size: cover;
      }
    }
  }
}
</style>
